import React from 'react';
import { StyleSheet, View } from 'react-native';
import TouchableNative from './TouchableNative';
import Text from './Text';
import { toSentenceCase } from '../../shared/utilities/stringsutils';
import { trackButtonPress } from '../../shared/utilities/gatracker';
import setTestID from '../../shared/utilities/setTestID';
import useThemeContext from '../styles/useThemeContext';

const TextButton = (props) => {
  const {
    disabled,
    style,
    text,
    gray,
    lightGreen,
    textColor,
    ignoreSentenceCase,
  } = props;

  const { colors } = useThemeContext();
  const Touch = disabled ? View : TouchableNative;

  const onPress = (event) => {
    if (props.disabled) {
      return;
    }
    trackButtonPress('Button ' + (props.tag || props.text));
    props.onPress && props.onPress(event);
  };

  if (text || props.children) {
    return (
      <Touch
        {...props}
        onPress={onPress}
        {...setTestID(props.tag || props.text)}
        style={[
          styles.root,
          {
            backgroundColor: 'none',
          },
          style,
        ]}
      >
        {text ? (
          <Text
            style={{
              textAlign: 'center',
              color:
                textColor ||
                (disabled
                  ? colors.lightGray
                  : gray
                    ? colors.gray
                    : lightGreen
                      ? colors.lightGreen
                      : colors.buttonBlue),
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            {ignoreSentenceCase ? text : toSentenceCase(text)}
          </Text>
        ) : (
          props.children
        )}
      </Touch>
    );
  }
};

const styles = StyleSheet.create({
  root: {
    paddingVertical: 6,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    minHeight: 40,
  },
});

export default TextButton;
